import styled, { css } from 'styled-components';
import { tenantBubbleStyles } from './TenantDropdown.styles';
import { borderedOutline } from '../../../theme/mixins';

const logoBase = css`
  border-radius: 50%;
  object-fit: cover;
  flex: 0 0 auto;
  background: ${({ theme }) => theme.palette.background.primary};
`;

export const SLogo = styled.img<{ $size?: number; $bordered?: boolean }>`
  ${logoBase};
  width: ${({ $size = 32 }) => `${$size}px`};
  height: ${({ $size = 32 }) => `${$size}px`};
  ${({ $bordered }) => $bordered && borderedOutline};
`;

export const SLogoFallback = styled.div<{ $size?: number; $bordered?: boolean }>`
  ${logoBase};
  width: ${({ $size = 32 }) => `${$size}px`};
  height: ${({ $size = 32 }) => `${$size}px`};
  display: grid;
  place-items: center;
  background: ${({ theme }) => theme.palette.background.buttonPrimary};
  color: ${({ theme }) => theme.palette.text.buttonPrimary};
  font-size: ${({ $size = 32 }) => `${Math.round($size * 0.4)}px`};
  font-weight: 600;
  ${({ $bordered }) => $bordered && borderedOutline};
`;

/**
 * Real tenant logo painted on top of `SLogoFallback`. Stays at opacity 0 until
 * `<img onLoad>` flips `$loaded`, then fades in over the initials placeholder.
 */
export const SLogoOverlay = styled(SLogo)<{ $loaded: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${({ $loaded }) => ($loaded ? 1 : 0)};
  transition: opacity 200ms ease;
`;

export const SLogoWithBadge = styled.span`
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;

  ${tenantBubbleStyles}
`;
